import { render, staticRenderFns } from "./RecentContacts.vue?vue&type=template&id=52643562&scoped=true&"
import script from "./RecentContacts.vue?vue&type=script&lang=js&"
export * from "./RecentContacts.vue?vue&type=script&lang=js&"
import style0 from "./RecentContacts.vue?vue&type=style&index=0&id=52643562&prod&scoped=true&lang=css&"
import style1 from "./RecentContacts.vue?vue&type=style&index=1&id=52643562&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52643562",
  null
  
)

export default component.exports